import { useSelector } from "react-redux";
import AcceptZoomModal from "../VendorOffers/AcceptZoomModal";
import CallDetailsModal from "../VendorOffers/CallDetailsModal";
import { useEffect, useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { FaChevronDown } from "react-icons/fa";
import { Button } from "reactstrap";
import ScheduleCallModal from "../VendorOffers/ScheduleCallModal";
import InPersonMeetingModal from "../VendorOffers/InPersonMeetingModal";
import { ListMessageMeeting } from "../../../../components/Header/Data3";

const CallDetails = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(false);
  const msg = useSelector((state) => state.messages.selectedConvo);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [acceptZoom, setAcceptZoom] = useState(false);
  const [scheduleCall, setScheduleCall] = useState(false);
  const [reSchedule, setReSchedule] = useState(false);
  const [missedCall, setMissedCall] = useState(false);
  const [callDetails, setCallDetails] = useState(false);
  const [inPersonMeeting, setInPersonMeeting] = useState(false);
  const [updateInPersonMeeting, setUpdateInPersonMeeting] = useState("");
  const [meetingData, setMeetingData] = useState({});
  //   const selectedMsg = msg; // Assuming you have msg from props or state

  const renderButton = () => {
    // if (msg.postType !== 3) return null;
    switch (msg.zoomStatus) {
      case 0:
        return (
          <>
            {msg.messageStatus !== 2
              ? msg?.messageStatus !== 15
                ? "Meeting Not Scheduled"
                : "Meeting Scheduled"
              : "Can't Schedule"}
          </>
        );

      case 1:
        return user.RoleId !== 1 && msg.zoomRole !== user.UserID
          ? "Call Requested"
          : "Call Request Sent";
      case 2:
        return "Rejected";
      case 3:
        return "Call Scheduled";
      case 4:
        return msg.zoomRole !== user.UserID
          ? "View Reschedule"
          : "Call Rescheduled";
      case 5:
        return "Call Not Attended";
      case 6:
        return " Call Discussed";
      case 7:
        return "Call Cancelled";
      case 8:
        return meetingData?.received_by !== user?.UserID
          ? "Meeting Request Sent"
          : "Meeting Requested";
      case 9:
        return "Meeting Rejected";
      case 10:
        return "Meeting Scheduled";
      case 11:
        return meetingData?.received_by !== user?.UserID
          ? "View Reschedule"
          : "Meeting Rescheduled";
      case 12:
        return "Meeting Completed";
      default:
        return null;
    }
  };
  const getButtonBackgroundColor = () => {
    switch (msg.zoomStatus) {
      case 0:
        return "#f5c6cb"; // Light red for "Call Not Scheduled"
      case 1:
        return "#ffdd57"; // Yellow for "Call Requested"
      case 2:
        return "#dc3545"; // Red for "Rejected"
      case 3:
        return "#28a745"; // Green for "Call Scheduled"
      case 4:
        return "#ffc107"; // Amber for "Call Rescheduled"
      case 5:
        return "#007bff"; // Blue for "Call Not Attended"
      case 6:
        return "#17a2b8"; // Teal for "Call Discussed"
      case 7:
        return "#6c757d"; // Gray for "Call Cancelled"
      case 8:
        return "#ffdd57"; // Yellow for "Meeting Requested"
      case 9:
        return "#f5c6cb"; // Yellow for "Meeting Rejected"
      case 10:
        return "#28a745"; // Green for "Meeting Scheduled"
      case 11:
        return "#ffdd57"; // Green for "Meeting Rescheduled"
      case 12:
        return "#17a2b8";
      default:
        return msg?.messageStatus === 15 ? "#28a745" : "#fdaec9"; // Default light pink if no status matches
    }
  };
  const handleAccept = (event, msg) => {
    event.stopPropagation();
    setAcceptZoom(true);
  };
  const closeZoomModal = (e) => {
    // e.stopPropagation();
    setAcceptZoom(false);
    setReSchedule(false);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const handleCallDetails = () => {
    if (
      msg?.zoomStatus === 8 ||
      msg?.zoomStatus === 9 ||
      msg?.zoomStatus === 10 ||
      msg?.zoomStatus === 11
    ) {
      setInPersonMeeting(true);
      setUpdateInPersonMeeting("List");
    } else {
      setCallDetails(true);
    }
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const handleSchedule = () => {
    setScheduleCall(true);
    setReSchedule(false);
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const handleInPersonMeeting = () => {
    setInPersonMeeting(true);
    setUpdateInPersonMeeting("Create");
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const fetchListMessageMeeting = async () => {
    const Id = user && user.UserID;
    const meetingDetails = await ListMessageMeeting(Id);
    const selectedMeetingData = meetingDetails.filter(
      (meeting) => parseInt(meeting?.message_id) === msg?.Id
    );
    setMeetingData(selectedMeetingData[selectedMeetingData.length - 1]);
  };

  useEffect(() => {
    fetchListMessageMeeting();
  }, [msg]);
  return (
    <div>
      <div className="wc-chat-drop" style={{ height: "26px" }}>
        <Button
          className="drop-button"
          style={{
            backgroundColor: getButtonBackgroundColor(),
            color: "black",
            fontSize: "small",
          }}
          size="sm"
          onClick={handleClick}
        >
          <span className="drop-button-title">
            {renderButton()}
            <FaChevronDown size={10} />
          </span>
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={currentMenu}
          onClose={handleClose}
          PaperProps={{
            style: {
              minWidth: "120px",
              maxWidth: "200px",
            },
          }}
          disableScrollLock={true}
        >
          {msg?.zoomStatus === 0 ||
          msg.zoomStatus === 6 ||
          msg?.zoomStatus === 7 ||
          msg?.zoomStatus === 9 ||
          msg.zoomStatus === 12 ? (
            <>
              <MenuItem
                onClick={handleInPersonMeeting}
                style={{ fontSize: "14px" }}
              >
                Schedule in-person meeting
              </MenuItem>
              <MenuItem onClick={handleSchedule} style={{ fontSize: "14px" }}>
                Schedule virtual meeting
              </MenuItem>
            </>
          ) : (
            <MenuItem onClick={handleCallDetails}>View Call Details</MenuItem>
          )}
        </Menu>
      </div>
      <InPersonMeetingModal
        isOpen={inPersonMeeting}
        closeModal={() => setInPersonMeeting(false)}
        updateInPersonMeeting={updateInPersonMeeting}
        meetingData={meetingData}
        setUpdateInPersonMeeting={setUpdateInPersonMeeting}
      />
      <CallDetailsModal
        isOpen={callDetails}
        closeModal={() => {
          setCallDetails(false);
          setReSchedule(false);
          setMissedCall(false);
        }}
        msg={msg}
        reSchedule={reSchedule}
        setReSchedule={setReSchedule}
        missedCall={missedCall}
        setMissedCall={setMissedCall}
      />
      <AcceptZoomModal
        isOpen={acceptZoom}
        closeModal={(e) => closeZoomModal(e)}
        reSchedule={reSchedule}
        setReSchedule={setReSchedule}
        msg={msg}
      />
      <AcceptZoomModal
        isOpen={acceptZoom}
        closeModal={(e) => closeZoomModal(e)}
        reSchedule={reSchedule}
        setReSchedule={setReSchedule}
        msg={msg}
      />
      <ScheduleCallModal
        isOpen={scheduleCall}
        closeModal={() => setScheduleCall(false)}
        msg={msg}
      />
    </div>
  );
};

export default CallDetails;
